import {
  APP_START,
  BULK_EDITOR_PANE_TOGGLE,
  UPDATE_DATA_SOURCE,
  SET_SPEND_DURATION,
} from '../actionTypes/app.js'

export const appStart = () => {
  return {
    type: APP_START,
  }
}

export const toggleBulkEditorPane = () => {
  return {
    type: BULK_EDITOR_PANE_TOGGLE
  }
}

export const updateDataSource = (dataSource) => (dispatch) => {
  dispatch({
    type: UPDATE_DATA_SOURCE,
    data: dataSource,
  })
}

export const setSpendDuration = ({ spendTimeFrame, spendTimeType }) => (dispatch) => {
  dispatch({
    type: SET_SPEND_DURATION,
    data: {
      spendTimeFrame: spendTimeFrame,
      spendTimeType: spendTimeType,
    },
  })
}